import React from 'react';

interface ProducerColumnProps {
    name: string;
    isEditAllowed: boolean;
    isActive: boolean;
    onSelected(): void;
}

const ProducerColumn: React.FC<ProducerColumnProps> = React.memo(props => {
    if (!props.isEditAllowed)
        return <>props.name</>;

    else if (!props.isActive)
        return <span style={{ color: "gray" }}>{props.name}</span>

    return <button className="link-button" onClick={() => props.onSelected()} >
        {props.name}
    </button>
});

export default ProducerColumn;